var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.91,
    height: 23.484,
    viewBox: "0 0 10.91 23.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M335.483,735.183v11.354a.3.3,0,0,0,.3.3h4.216a.3.3,0,0,0,.3-.3V735h3.057a.3.3,0,0,0,.295-.271l.294-3.476a.3.3,0,0,0-.295-.321h-3.351v-2.466a1.047,1.047,0,0,1,1.047-1.047h2.356a.3.3,0,0,0,.3-.3v-3.476a.3.3,0,0,0-.3-.3h-3.981a4.23,4.23,0,0,0-4.23,4.23v3.352h-2.108a.3.3,0,0,0-.3.3V734.7a.3.3,0,0,0,.3.3h2.108Z",
    transform: "translate(-333.079 -723.348)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.03c2ac851cda48b1d769daa01efcaf02.svg";
export { ForwardRef as ReactComponent };